import React from "react";
import {
  getCurrentStepKey,
  getStepKey,
  getStepLabel,
  isStepBeforeWorkflow,
  isWizardStepLocked,
  stepKeysEqual
} from "./resourceConfigWizardUtils";

const WizardProgress = ({ steps, activeStepKey, wizard, disabled, onSelectStep }) => (
  <nav className="resource-wizard__steps" aria-label="Resource configuration phases">
    {steps.map((step, index) => {
      const stepKey = getStepKey(step);
      const completed = isStepBeforeWorkflow(wizard, stepKey)
        || (stepKeysEqual(stepKey, "complete") && stepKeysEqual(getCurrentStepKey(wizard), "complete"));
      const locked = isWizardStepLocked(wizard, stepKey);
      const active = String(stepKey || "").toLowerCase() === String(activeStepKey || "").toLowerCase();
      return (
        <button
          key={stepKey}
          type="button"
          data-step-key={stepKey}
          className={`resource-wizard__step${active ? " active" : ""}${completed ? " completed" : ""}${locked ? " locked" : ""}`}
          onClick={() => onSelectStep(stepKey)}
          disabled={(disabled && !active) || locked}
        >
          <span>{index + 1}</span>
          {getStepLabel(step)}
        </button>
      );
    })}
  </nav>
);

export default WizardProgress;
